import { StringUtil } from './string.util'
import { ReceiptItem } from './receipt-item'
import { ReceiptInfo } from './receipt-info'
import { ReceiptPrototype } from './receipt.prototype'

export class MkOutletReceipt extends ReceiptPrototype {

  constructor(text: string = null, private tools = new StringUtil()) {
    super()
    if (text) { this.process(text); }
  }

  public process(text: string): void {
    const lines = this.tools.getCleanLines(text)
    this.items = this.getItemBlocks(lines).map(block => this.processItemBlock(block))
    this.info = this.processInfo(lines)
    this.items.forEach(x => x.tax_rate = x.taxed ? this.info.tax_rate : 0)
  }

  private processInfo(lines: string[]): ReceiptInfo {
    let subtotal = 0, overall_discount = 0, tax = 0, date = new Date().toISOString().slice(0, 10), purchaser = ''
    const info = new ReceiptInfo()
    lines.forEach((x, i) => {
      if (x.indexOf('customer') >= 0 && !purchaser) { purchaser = x.slice('customer'.length + 1); }
      if (x.indexOf('subtotal') >= 0) { subtotal = this.tools.firstNumberOfString(x); }
      if (x.indexOf('trans coupon discount') >= 0) {
        overall_discount = Number(x.slice(x.indexOf('$') + 1, x.indexOf(')')).replace(',', ''));
      }
      if (x.indexOf('tax') >= 0) { tax = this.tools.lastNumberOfString(x); }
      if (x.indexOf('date:') >= 0) { date = new Date(x.split(' ')[1]).toISOString().slice(0, 10); }
      if (x.match(this.datePattern)) { date = new Date(x.match(this.datePattern)[0]).toISOString().slice(0, 10); }
    })
    return new ReceiptInfo({
      subtotal: subtotal - overall_discount,
      tax: tax,
      date: date,
      purchaser: purchaser
    })
  }

  private processItemBlock(lines: string[]): ReceiptItem {
    let price = 0, discount = 0
    price = this.tools.firstNumberOfString(lines[0])
    for (let j = 1; j < lines.length; j ++) {
      if (lines[j].indexOf('new price') >= 0) {
        price = this.tools.firstNumberOfString(lines[j])
      }
      if (['item coupon discount', 'item discount'].some(x => lines[j].indexOf(x) >= 0)) {
        discount += this.tools.lastNumberOfString(lines[j])
      }
    }
    return new ReceiptItem({
      barcode: lines[0].slice(0, 12),
      brand: 'mk',
      category: '包袋',
      name: lines[2].slice(7) + ' ' + lines[0].split(' ')[1],
      count: 1,
      pre_tax_price: price - discount
    })
  }

  private getItemBlocks(lines: string[], exp = this.stylePattern): string[][] {
    let start = 0, line = '';
    const blocks: string[][] = [];
    for (let i = 0; i < lines.length; i ++) {
      line = lines[i]
      if (line.match(exp) && line.match(exp).length === 1) {
        if (start > 0) { blocks.push(lines.slice(start, i)); }
        start = i
      } else if (start > 0 && line.indexOf('total') >= 0) {
        blocks.push(lines.slice(start, i - 1))
        break
      }
    }
    return blocks
  }

  get stylePattern(): RegExp {
    return /^\d{12}/
  }

  get datePattern(): RegExp {
    return /^[a-zA-Z]+\s\d{1,2}, \d{4}/
  }

}



// WEBPACK FOOTER //
// ./src/app/models/text-receipt/mk-outlet-receipt.ts